<template>
<div class="manager_dashboard">
   <user-menu />
  <div class="wrapper">
    <masteradmin-sidebar-menu />
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
          <h3 class="d-inline heading">Add Master Admin</h3>
        </div>
        <div class="heading-seperator"></div>
        <div class="content-main-wrapper signin-form add_account_form center">
            <adminform :first_name="first_name" :last_name="last_name" :phone_number="phone_number" :email_addr="email_addr" :password="password" :pw_confirm="pw_confirm" :submit="submit" :action="action"></adminform>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import adminform from './adminform.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
	    password: '',
      pw_confirm: '',
      submit: 'Create Master Admin',
	    action: 'insert',
    }
  },
  components: {
    adminform,
    UserMenu,
    GoBack,
    MasteradminSidebarMenu,
  },

}
</script>



// WEBPACK FOOTER //
// src/components/admin/add_admin.vue